module.exports = __webpack_public_path__ + "media/img/uploads/sdks_header_img-14e4ce523dc591927e5afe52e49a2571.png";